import { create } from "zustand";
import { InitializePaginationProperties, InitializeSetPaginationProperties, PaginationProperties, SetPaginationProperties } from "../../../../../common/utils/pagination_property";

/**
 * useObrasDocumentosPagination
 */

type State = PaginationProperties;

type Actions = SetPaginationProperties;

export const useObrasDocumentosPagination = create<State & Actions>((set) => ({
  ...InitializePaginationProperties(),
  ...InitializeSetPaginationProperties(set),
}));